import { attach } from 'effector';

import { api } from '@shared/api/api';

const signUpFx = attach({ effect: api.auth.signupInit });

export { signUpFx };
